import type { ReactNode } from 'react'
import * as AlertDialog from '@radix-ui/react-alert-dialog'

// Replaces the hand-rolled inline "Zeker weten? [confirm] [Annuleren]" pattern that was
// copy-pasted across Sites.tsx, SiteDetail.tsx and ApiKeys.tsx — no focus trap, no Escape
// to close, no click-outside-to-dismiss, and each copy could drift. Radix's AlertDialog
// gives all of that for free; this wrapper only adds the app's own visual theme on top.
export function ConfirmDialog({
  trigger,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Annuleren',
  destructive,
  busy,
  onConfirm,
}: {
  trigger: ReactNode
  title: string
  description: ReactNode
  confirmLabel: string
  cancelLabel?: string
  destructive?: boolean
  busy?: boolean
  onConfirm: () => void
}) {
  return (
    <AlertDialog.Root>
      <AlertDialog.Trigger asChild>{trigger}</AlertDialog.Trigger>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-20 bg-black/60 data-[state=open]:animate-in data-[state=open]:fade-in" />
        <AlertDialog.Content className="fixed left-1/2 top-1/2 z-30 w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-xl border border-line bg-card p-5 shadow-xl focus:outline-none">
          <AlertDialog.Title className="mb-2 text-base font-semibold text-ink">{title}</AlertDialog.Title>
          <AlertDialog.Description className="mb-5 text-sm text-ink-soft">{description}</AlertDialog.Description>
          <div className="flex justify-end gap-3">
            <AlertDialog.Cancel asChild>
              <button type="button" className="text-sm text-ink-soft hover:text-ink">
                {cancelLabel}
              </button>
            </AlertDialog.Cancel>
            <AlertDialog.Action asChild>
              <button
                type="button"
                disabled={busy}
                onClick={onConfirm}
                className={
                  destructive
                    ? 'rounded-lg bg-[#C1666B] px-4 py-2 text-sm font-semibold text-white hover:opacity-90 disabled:opacity-50'
                    : 'rounded-lg bg-amber px-4 py-2 text-sm font-semibold text-[#0E2A3B] hover:opacity-90 disabled:opacity-50'
                }
              >
                {confirmLabel}
              </button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
